module.exports = __webpack_public_path__ + "static/media/ecoSave.3984788c.svg";